enum ResultsType {
  SKILLSET = 'skillset',
  MINDSET = 'mindset',
  BEHAVIOUR = 'behaviour'
}

export default ResultsType;
